import axios from "axios";

const OUTSIDE_MSG = "Pickup location is outside service area";

/**
 * True when a place has usable lat/lng (e.g. after choosing a Google Places suggestion).
 * Typing an address alone does not set coordinates until a suggestion is selected.
 * @param {{ lat?: unknown, lng?: unknown } | null | undefined} place
 */
export function hasResolvedPlaceCoords(place) {
  if (!place) return false;
  // null must not pass: Number(null) === 0 (false "valid" coords).
  if (place.lat == null || place.lng == null || place.lat === "" || place.lng === "") {
    return false;
  }
  const lat = Number(place.lat);
  const lng = Number(place.lng);
  return Number.isFinite(lat) && Number.isFinite(lng);
}

/**
 * @param {number|string|null|undefined} lat
 * @param {number|string|null|undefined} lng
 * @returns {Promise<{ ok: boolean, message?: string }>}
 */
export async function validatePickupServiceArea(lat, lng) {
  const la = lat != null && lat !== "" ? Number(lat) : NaN;
  const ln = lng != null && lng !== "" ? Number(lng) : NaN;
  if (Number.isNaN(la) || Number.isNaN(ln)) {
    return { ok: false, message: "Invalid coordinates" };
  }

  try {
    const { data, status } = await axios.post(
      `${process.env.REACT_APP_APP_DOMAIN}/api/customer/validate-pickup-location`,
      { lat: la, lng: ln },
    );
    if (data?.status === true) {
      return { ok: true };
    }
    return {
      ok: false,
      message: data?.message || OUTSIDE_MSG,
    };
  } catch (error) {
    const msg =
      error.response?.data?.message ||
      (error.response?.status === 422 ? OUTSIDE_MSG : null) ||
      "Failed to validate location.";
    return { ok: false, message: msg };
  }
}

export const PICKUP_OUTSIDE_SERVICE_MESSAGE = OUTSIDE_MSG;

/** True for check-fare / validate API messages that refer to service area. */
export function isOutsideServiceAreaMessage(msg) {
  if (!msg || typeof msg !== "string") return false;
  const m = msg.toLowerCase();
  return (
    m.includes("outside service area") ||
    m.includes("no service area available")
  );
}
